import { styleModelOptions } from "@/constants";
import { useModelStore } from "@/store/model";

/**
 * 处理埋点list函数
 */
export function handleEventTracking(modelList: any[]) {
  const modelStore = useModelStore();
  const modelIdList = modelList.map((i: any) => i.id) || [];
  const modelNameList = modelList.map((i: any) => i.modelName) || [];

  const modelLabels = modelList.flatMap((item) => item.label || []).filter(Boolean);
  // 按照 modelLabels 中 ID 的顺序过滤和排序标签
  const modelTagList = modelLabels
    .map((labelId: any) => modelStore.labelOptions.find((item: any) => item.value === labelId))
    .filter(Boolean)
    .map((item: any) => item!.label);

  const modelCategories = modelList.map((item: any) => item.category).filter(Boolean);

  const modelTypeList = modelCategories
    .map((categoryId: any) => modelStore.categoryOptions.find((item: any) => item.value === categoryId))
    .filter(Boolean)
    .map((item: any) => item!.label);

  // 创建loraType映射关系
  const loraTypeMap = Object.fromEntries(styleModelOptions.map((option) => [option.value, option.label]));
  // 提取loraType对应的label组成数组
  const loraTypeLabels = modelList.map((item: any) => (item?.loraType ? loraTypeMap[item.loraType] || "视频模型" : ""));

  return {
    hp_model_id_list: modelIdList,
    hp_model_name_list: modelNameList,
    hp_model_type_list: modelTypeList,
    hp_model_tags_list: modelTagList,
    is_composite_model: loraTypeLabels
  };
}
